module.exports = __webpack_public_path__ + "static/media/iconeWindows.59276d09.png";